import { PersistentStore, saveAndSync, syncOperation } from '@/utils/PersistentStore';
import { GetterTree, ActionTree } from 'vuex';
import vuestore from '@/store';
import { replaceInArray } from '@/utils/Array';
import { mediaService } from '../services/mediaService';
import { CreateTypedStoreProxy } from 'vuex-typed-store';
import { Guid } from 'guid-typescript';

export interface MediaStoreModel { }

interface MediaStoreActions {
  set: (payload: server.mediaUpload) => any
  remove: (payload: server.mediaDetail) => any
}

interface MediaStoreGetters {
  get(id: number, type: string): Promise<server.mediaDetail[]>;
}

export const TABLES = {
  media: 'media',
}

export const MediaStore = {
  PREFIX: 'media',
  namespaced: true,
  getters: {
    get: (state) => async (id: number, type: string): Promise<server.mediaDetail[]> => {
      var result = (await PersistentStore.getAll<server.mediaDetail>(TABLES.media) || []).filter(i => i.typeId == id && i.type == type);
      mediaService.List(id, type).then(async r => {
        replaceInArray(r, result, (a, b) => a.id == b.id);
        await PersistentStore.set(TABLES.media, r);
      });
      return result;
    },
  } as GetterTree<MediaStoreModel, MediaStoreGetters>,
  actions: {
    async set(context, payload: server.mediaDetail) {
      // let operation = syncOperation.noop;
      // if (!payload.id && !payload.typeId) {
      //   payload.id = Guid.create().toString();
      //   operation = syncOperation.create;
      // }

      await saveAndSync<server.mediaDetail>(payload, TABLES.media,
        // scelgo l'operazione
        i => {
          return i.id < 0 && i.typeId ? syncOperation.create : syncOperation.noop
        },

        // dummy... non faccio mai un aggiornamento della immagine
        async i => {
          return i;
        },

        // in caso di salvataggio del dato.. 
        i => {
          return mediaService.Upload(i as server.mediaUpload);
        },

        // salvataggio avvenuto con successo
        async (oldpayload, newpayload, operation) => {
          Object.assign(payload, newpayload);
        })
    },
    async remove(context, payload: server.mediaDetail) {
      if (payload.id > 0) {
        try {
          await mediaService.Remove(payload.id, payload.container);
        } catch (err) {
          console.error('error removing media from server', payload)
        }
      }
      await PersistentStore.remove(TABLES.media, payload);

    }
  } as ActionTree<MediaStoreModel, MediaStoreActions>

};

export const mediaStore = CreateTypedStoreProxy<MediaStoreModel, MediaStoreActions, MediaStoreGetters>(vuestore, MediaStore.PREFIX);


